<div class="u-badge {{ styleClass() }}">
  {{ text() }}
</div>
